module.exports = __webpack_public_path__ + "img/eFilling.338e2975.jpg";